var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import Helper from '@ember/component/helper';
import { assert } from '@ember/debug';
import Enum from '@square/dashboard-utilities/utils/enum';
export const NameViewType = new Enum('FIRST_LAST', 'LAST_COMMA_FIRST', 'LAST_FIRST');
let NameViewFullName = (_class = class NameViewFullName extends Helper {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
  }
  compute([person, nameViewType]) {
    if (!person) {
      return null;
    }
    const {
      firstName,
      lastName
    } = person;
    if (!firstName && !lastName) {
      return null;
    }
    if (!lastName) {
      return firstName;
    }
    if (!firstName) {
      return lastName;
    }
    switch (nameViewType) {
      case NameViewType.FIRST_LAST:
        return `${firstName} ${lastName}`;
      case NameViewType.LAST_FIRST:
        return `${lastName} ${firstName}`;
      case NameViewType.LAST_COMMA_FIRST:
        {
          const separator = this.i18n.t('common.toSentence.wordsConnector');
          return `${lastName}${separator} ${firstName}`;
        }
      default:
        assert(`expected a nameViewType, got ${nameViewType}`);
        return `${firstName} ${lastName}`;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { NameViewFullName as default };